import axios from 'axios'
import { LocalStorage as SessionStorage } from 'quasar'

const endPoint = "user"

export function verifyRegistrationCode({ state, commit }) {

    let log = {
        app_id: 'customer_web_app',
        function: 'verifyRegistrationCode',
        endpoint: `${endPoint}/verifyregistrationcode`,
        method: 'post',
        request: { 'registration_code': state.registration_code },
        status: {}
    }

    return new Promise((resolve, reject) => {
        axios
            .post(`${endPoint}/verifyregistrationcode`, { 'registration_code': state.registration_code })
            .then(response => {
                commit('setFormStep', 1)
                log.status = response.status
                this.dispatch('miscellaneous/logEvent', log)
                resolve(response)
            })
            .catch(err => {
                log.status = err.response.status
                this.dispatch('miscellaneous/logEvent', log)
                reject(err)
            })
    })
}

export function userRegistration({ state, commit }) {

    return new Promise((resolve, reject) => {

        let formData = new FormData()
        formData.append('registration_code', state.registration_code == null ? '' : state.registration_code)
        formData.append('f_name', state.f_name)
        formData.append('l_name', state.l_name)
        formData.append('email', state.email)
        formData.append('terms_of_service', state.terms_of_service)
        formData.append('university_student', state.university_student)
        formData.append('employee', state.employee)
        formData.append('password', state.password)
        formData.append('password_confirmation', state.confirm_password)
        formData.append('job_title', state.title)
        formData.append('mob_no', state.phone)
        formData.append('std_code', state.std_code)
        formData.append('city', state.city)
        formData.append('country', state.country)
        formData.append('birth_date', state.birth_date)
        formData.append('birth_month', state.birth_month)

        formData.append('birth_year', state.birth_year ? state.birth_year : '')

        formData.append('role_name', state.role_name == 'Student_Coachees' ? 'Student' : state.role_name)
        formData.append('title', state.title)
        formData.append('university', state.university)
        formData.append('degree', state.degree)
        formData.append('company', state.employer)
        formData.append('timezone', state.timezone)
        formData.append('company_role_id', state.company_role_id)
        formData.append('department_id', state.department_id)
        formData.append('profile_image', state.profile_image)

        let log = {
            app_id: 'customer_web_app',
            function: 'userRegistration',
            endpoint: "/user",
            method: 'post',
            request: formData,
            status: {}
        }

        var registration_token = JSON.parse(SessionStorage.getItem('registration_token'))

        axios
            .post('/user', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${registration_token}`
                },
            })
            .then(response => {
                log.status = response.status;
                this.dispatch('miscellaneous/logEvent', log)
                resolve(response.data)
            })
            .catch(err => {
                //log.status = err.response.status // This is malformed
                this.dispatch('miscellaneous/logEvent', log)
                reject(err)
            })
    })
}

// Update profile function
export function updateProfileImage({ state }, data) {


    let log = {
        app_id: 'customer_web_app',
        function: 'updateProfileImage',
        endpoint: endPoint + "/changeProfileImage/" + data._id,
        method: 'post',
        request: data.formData,
        status: {}
    }

    return new Promise((resolve, reject) => {
        axios
            .post(endPoint + "/changeProfileImage/" + data._id, data.formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            })
            .then(response => {
                // this.dispatch('auth/fetchAuthUser')
                log.status = response.status
                this.dispatch('miscellaneous/logEvent', log)
                resolve(response.data)
            })
            .catch(err => {
                log.status = err.response.status
                this.dispatch('miscellaneous/logEvent', log)
                reject(err)
            })
    })
}

export function resetStore({ commit, store }) {
    commit('resetStore')
}
